<template>
	<div class="ts-space-y-2">
		<fieldset>
			<legend class="text-blue">
				{{ $t('promotionPackage.productLists') }}
				<Tooltip placement="top">
					<Icon type="ios-information-circle-outline" size="17" />
					<div slot="content">
						<div class="ts-text-xs">
							{{ $t('promotionPackage.productLists') }}
						</div>
					</div>
				</Tooltip>
			</legend>
			<div class="ts-space-y-2">
				<div class="row">
					<div class="col-md-4">
						<a-select v-model="filter.pro_group_id" :options="productGroupFilters" show-search allowClear
							option-filter-prop="children" class="ts-w-full" style="height: 30px;"
							:placeholder="$t('promotionPackage.filterByGroup')"></a-select>
					</div>
					<div class="col-md-3"></div>
					<div class="col-md-5">
						<input v-model.trim="filter.search" type="text" :placeholder="$t('search')"
							class="form-control" />
					</div>
				</div>
				<div class="row">
					<div class="col-md-12 overflow-auto">
						<div class="table-ui-detail" style="min-height: 300px; max-height: 420px">
							<table class="ts-w-full" style="max-height: 420px">
								<thead>
									<tr>
										<th width="12%">
											{{ $t('promotionPackage.productGroup') }}
										</th>
										<th width="10%">
											{{ $t('promotionPackage.barcode') }}
										</th>
										<th width="20%">
											{{ $t('promotionPackage.product') }}
										</th>
										<th width="10%">
											{{ $t('promotionPackage.uom') }}
										</th>
										<th width="10%">
											{{ $t('promotionPackage.quantity') }}
										</th>
										<th width="15%">
											{{ $t('promotionPackage.unitPrice') }}
										</th>
										<th width="10%">
											{{ $t('promotionPackage.discount') }}
										</th>
										<th width="10%">
											{{ $t('promotionPackage.discountType') }}
										</th>
										<th width="3%" class="ts-px-2 ts-whitespace-no-wrap ts-text-center"></th>
									</tr>
								</thead>
								<tbody>
									<tr v-if="products.length == 0">
										<td colspan="8" class="ts-text-center ts-p-3 ts-space-x-1">
											<i class="fa fa-folder-open ts-text-gray-200"></i>
											<label class="ts-text-gray-400">
												{{ $t('noData') }}
											</label>
										</td>
									</tr>
									<tr v-if="products.length > 0" v-for="(product, index) in products"
										:value="product.product_id" :key="index"
										class="ts-cursor-pointer hover:ts-bg-gray-300">
										<td class="ts-px-2">
											{{ product.pro_group_name_en }}
										</td>
										<td class="ts-px-2">
											{{ product.barcode }}
										</td>
										<td class="ts-px-2">
											{{ product.product_name_en }}
										</td>
										<td>
											<a-select v-model="product.uom_id"
												:options="getUnitOfMeasures(product.uom_cat_id)"
												option-filter-prop="children" class="ts-w-full" placeholder="Select"
												@change="onUomChange(product)"></a-select>
										</td>
										<td>
											<input type="number" class="form-control ts-text-center"
												v-model.number="product.quantity" />
										</td>
										<td class="ts-text-right">
											<ts-currency-converter-input :input_amount.sync="product.input_unit_price"
												:amount.sync="product.unit_price"
												:input_currency_id.sync="product.input_currency_id"
												:currency_id.sync="product.currency_id" :fx_rate.sync="product.fx_rate"
												:fx_rate_ratio.sync="product.fx_rate_ratio" />
										</td>
										<td>
											<input v-if="product.discount_type == '%'" ref="discountRate" type="number"
												v-model.number="product.input_discount_rate" class="form-control"
												@change="onChangeItem(product)" />
											<ts-currency-converter-input v-else
												:input_amount.sync="product.input_discount_rate"
												:amount.sync="product.discount_rate"
												:input_currency_id.sync="product.input_currency_id"
												:currency_id.sync="product.currency_id" :fx_rate.sync="product.fx_rate"
												:fx_rate_ratio.sync="product.fx_rate_ratio" style="min-width: 120px;" />
										</td>
										<td>
											<a-select v-model="product.discount_type" class="ts-w-full"
												style="min-width: 50px" @change="onChangeItem(product)">
												<a-select-option value="%">%</a-select-option>
												<a-select-option
													:value="getDiscountCurrency(product.input_currency_id)">
													{{ getDiscountCurrency(product.input_currency_id) }}
												</a-select-option>
											</a-select>
										</td>

										<td class="ts-px-2 ts-whitespace-no-wrap ts-text-center">
											<a href="#" class="ts-text-blue-500" @click.prevent="addItem(product)">
												<i class="fa fa-plus"></i>
											</a>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</fieldset>
	</div>
</template>

<script>
import { includes } from 'lodash';
import { mapState } from 'vuex'
export default {
	name: 'productList',
	props: ['value'],
	data() {
		return {
			filter: {
				search: '',
				pro_group_id: undefined,
			},
			model: {},
		}
	},
	created() {
		this.model = this.value
	},
	computed: {
		...mapState('promotion/promotionPackage', ['formViewDatas']),
		productGroupFilters() {
			if (this.formViewDatas['productGroups']) {
				return this.formViewDatas['productGroups'].map(el => ({
					value: el.pro_group_id,
					label: el.pro_group_name_en + (el.pro_group_name_kh ? '|' + el.pro_group_name_kh : ''),
				}))
			}
			return []
		},
		products() {
			if (this.formViewDatas['products']) {
				return this.formViewDatas['products']
					.filter(p => this.filter.pro_group_id ? p.pro_group_id == this.filter.pro_group_id : true)
					.filter(p => !includes(this.model.details.map(el => el.product_id), p.product_id))
					.filter(
						p => this.filter.search
							.split(' ')
							.every(s =>
								p.barcode.toLowerCase().includes(s.toLowerCase())
							) ||
							this.filter.search
								.split(' ')
								.every(s => p.product_name_en.toLowerCase().includes(s.toLowerCase()))
					)
					.slice(0, 40)
			}
			return []
		},
		unitOfMeasures() {
			if (this.formViewDatas['unitOfMeasures']) {
				return this.formViewDatas['unitOfMeasures'].map(el => ({
					value: el.uom_id,
					label: el.uom_name_en,
					uom_cat_id: el.uom_cat_id,
					is_default: el.is_default,
					stockout_quantity: el.stockout_quantity
				}))
			}
			return []
		}
	},
	methods: {
		getUnitOfMeasures(uom_cat_id) {
			return this.unitOfMeasures.filter(el => el.uom_cat_id == uom_cat_id)
		},
		onUomChange(product) {
			const price = product.sale_code.find(el => el.uom_id == product.uom_id)
			product.input_cost = price ? price.cost : 0
			product.input_currency_id = product.currency_id
		},
		getDiscountCurrency(input_currency_id) {
			if (this.formViewDatas['currency']) {
				let currency = this.formViewDatas['currency'].find(
					el => el.currency_id == input_currency_id
				).currency_symbol

				return currency ? currency.currency_symbol : null
			}
			return null
		},
		onChangeItem(product) {
			if (product.discount_type == '%') {
				product.discount_rate = product.input_discount_rate
			} else {
				product.discount_type = this.getDiscountCurrency(product.input_currency_id)
				product.discount_rate = product.input_discount_rate * product.fx_rate_ratio
			}
		},
		addItem(product) {
			let newItem = {
				package_id: null,
				package_detail_id: null,
				product_id: product.product_id,
				uom_id: product.uom_id,
				quantity: product.quantity,
				currency_id: product.currency_id,
				input_currency_id: product.input_currency_id,
				fx_rate: product.fx_rate,
				fx_rate_ratio: product.fx_rate_ratio,
				unit_price: product.unit_price,
				input_unit_price: product.input_unit_price,
				sub_total: parseFloat(product.sub_total),
				input_sub_total: parseFloat(product.input_sub_total),
				discount_type: product.discount_type,
				discount_rate: product.discount_rate,
				input_discount_rate: product.input_discount_rate,
				discount_amount: parseFloat(product.discount_amount),
				input_discount_amount: parseFloat(product.input_discount_amount),
				vat_rate: parseFloat(product.vat_rate),
				vat_amount: parseFloat(product.vat_amount),
				grand_total: parseFloat(product.grand_total),
				input_grand_total: parseFloat(product.input_grand_total),
				stock_out_quantity: product.quantity,
				order: null,
			}
			this.model.details.push(newItem)
		},
	},
}
</script>

<style scoped>
.form-control {
	height: 30px;
}
</style>
<style>
.filter .ant-select-selection--single {
	height: 29px;
}

.ivu-checkbox-small {
	margin: 0;
}
</style>